import React from 'react';
import { ChangePasswordComponent } from '@/pages/users/auth/ChangePasswordComponent';
import { Lock } from 'lucide-react';

export const ChangePasswordSettings = () => {
  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="bg-white dark:bg-neutral-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-neutral-700">
        <div className="flex items-center gap-3 mb-6">
            <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                <Lock className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Change Password</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                    Update your password to keep your account secure
                </p>
            </div>
        </div>
        <ChangePasswordComponent />
      </div>
    </div>
  );
};
